import React from 'react';
import * as S from './style';
import { FormStatusInfo, Label } from 'components';
import { ReactComponent as ImgInterviewNoAnswer } from 'assets/img/status/img_interview_no_answer.svg';

interface Props {
    inactiveDueDate: string;
}

function InterviewNoAnswer({ inactiveDueDate }: Props): React.ReactElement {
    return (
        <FormStatusInfo subTitle={['인터뷰 미응답으로 휴면상태입니다.']} image={<ImgInterviewNoAnswer />} btnWidth={180} inHomeBtn={true}>
            <S.CaptionWrapper>
                {['인터뷰 미응답기사님으로 재심사 혹은 탈퇴를 원하시면 고객센터로', '연락 주시기 바랍니다.'].map((item, index) => (
                    <Label key={index} contents={item} color={'gray_opacity_600'} fontStyle={'body2'} />
                ))}
            </S.CaptionWrapper>
            <S.DateWrapper>
                <Label contents={'휴면 시작일'} color={'gray_opacity_600'} fontStyle={'body2'} />
                <Label contents={inactiveDueDate} color={'gray_opacity_800'} fontStyle={'body1'} />
            </S.DateWrapper>
        </FormStatusInfo>
    );
}

export default InterviewNoAnswer;
